import React, { useContext, useState } from 'react';
import { SettingsBannerContext } from '../../contexts/SettingsBannerContext';
import { MasterBannerContext } from '../../contexts/MasterBannerContext';
import { BuildCSS, verifyAnimation } from '../../helpers/buildVideo';
import Button from '@mui/material/Button';
import { EnviarHtmlVideo, ReceberVideo, VerificarStatusVideo, CriarPasta, DeletarPasta } from '../../services/auth'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import './index.css';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import { useAuth } from '../../hooks/useAuth'
import { BannerJson } from '../../helpers/buildBanner';
import useLocalStorage from "../../hooks/useLocalStorage";
import JSZip from 'jszip';

export default function Video() {
  const formats = [
    'MP4', 'FLV1', 'WMV1', 'GIF', 'WEBM'
  ]
  const [ value, setValue ] = useState(formats[0]);
  const [ configAvancada, setConfigAvancada ] = useState(false)
  const { setVideoModal, setLoading, setError } = useContext(SettingsBannerContext);
  const { master } = useContext(MasterBannerContext);
  const [ videoModel, setVideoModel ] = useState({
    html: "",
    duration: master ? parseFloat(master.duration + 1) * 1000 : 0,
    fps: 30,
    width: master ? master.width : 0,
    bitrate: 2000000,
    height: master ? master.height : 0,
    format: "mp4",
    quality: 100,
    audio: "",
    loop: false,
    bit: false,
    gifQuality: false
  });
  const { recordHash } = useAuth();  
  const [ , setTokenLocalStorage ] = useLocalStorage('@login-mastermotion/token', null);
  const [ userLocalStorage, setUserLocalStorage ] = useLocalStorage('@login-mastermotion/user', null);

  function getDuration(css) {
    try {
      const regex = /\s\d+(\.\d+)?s/;
      const r = css.toLowerCase().split("animation:")[1].split("}")[0];
      const result = r.match(regex);
      const extractedText = result[0].replace("s", "");
      return parseFloat(extractedText).toFixed(1) * 1000;
    } catch {
      return 1000;
    }
  }

  async function handleVideoExport() {
    setLoading({show: true, progress: 2});
    try {
      var copyVideoModel = JSON.parse(JSON.stringify(videoModel));
      var copyMaster = JSON.parse(JSON.stringify(master));
      var verify = verifyAnimation(copyMaster);
      copyMaster = verify.master;
      if (verify.erros.length > 0) {
        var erro = "";
        for (var i = 0; i < verify.erros.length; i++) {
          erro += "[" + verify.erros[i] + "] ";
        }
        setError(
          {
            mensagem: "Keyframe inválido",
            lista: [erro],
            show: true
          }
        )
        setLoading({show: false, progress: false});
        return;
      }
      var base64 = { base64: "", ext: "" };
      copyVideoModel.audio = master.audio && master.audio.b64 ? JSON.stringify(copyMaster.audio) : "";
      copyVideoModel.audioIA = master.audioIA && master.audioIA.b64 ? JSON.stringify(copyMaster.audioIA) : "";
      copyMaster.preset.forEach(element => {
        if (element.customKeyframe) {
          element.customKeyframe.duration = getDuration(element.customKeyframe.keyframe);
        }
      });
      copyVideoModel.html = BuildCSS(copyMaster);      
      try {
        copyVideoModel.usuario = userLocalStorage.email;
      } catch {}
      var pastaServidor = await CriarPasta();
      var enviarHtml = await EnviarHtmlVideo(copyVideoModel, pastaServidor);
      if (enviarHtml) {
        base64.base64 = enviarHtml.data.base64;
        base64.ext = enviarHtml.data.ext;
      } else {
        for (var i = 0; i < 360; i++) {
          await sleep(10000);
          console.log('pastaServidor')
          console.log(pastaServidor)
          var statusVideo = await VerificarStatusVideo(pastaServidor, copyVideoModel);
          setLoading({show: true, progress: statusVideo.percentual});
          if (statusVideo.finalizado) {
            var receberVideo = await ReceberVideo(pastaServidor, copyVideoModel);
            console.log('receberVideo')
            console.log(receberVideo)
            if (receberVideo.finalizado) {
              base64.base64 = receberVideo.blob;
              base64.ext = receberVideo.ext;
              break;
            }
          }
        }
      }
      DeletarPasta(pastaServidor);
      if (base64.base64 === "") {
        setError(
          {
            mensagem: "Erro ao exportar vídeo",
            lista: [""],
            show: true
          }
        )
      } else {
        var resVideo = await recordHash(await BannerJson(master, "video"));
        if (resVideo) {
          console.log('baixando video')
          downloadVideo(base64.base64, `${master.width}x${master.height}-${videoModel.fps}.${base64.ext}`);
        } else {          
          setError(
            {
              mensagem: "Erro ao exportar vídeo",
              lista: [""],
              show: true
            }
          )
        }
        if (!resVideo.allowed_access) {
          setTokenLocalStorage(null);
          setUserLocalStorage(null);
          window.location.replace('https://www.reanimateads.com.br')
        } else {
          console.log('sem redirecionar')
        }
      }      
      setVideoModal(false);
      setLoading({show: false, progress: false});
    } catch (error) {
      console.log(error)
      setVideoModal(false);
      setLoading({show: false, progress: false});
    }
  }

	function sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

  function downloadVideo(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
      URL.revokeObjectURL(url);
  }


  function disabledButton() {
    return !videoModel.duration || !videoModel.fps || !videoModel.width ||
    !videoModel.bitrate || !videoModel.height || !videoModel.format || !videoModel.quality;
  }

  function handleChange(key, value) {
    var copyVideoModel = JSON.parse(JSON.stringify(videoModel));
    copyVideoModel[key] = value;
    setVideoModel(copyVideoModel);
  }

  return (
    <div className='modal-video'>
      <div className='container-modal-video'>
        <HighlightOffIcon onClick={() => setVideoModal(false)} style={{ cursor: 'pointer', position: 'absolute', top: 10, right: 10}}/>
        <div style={{fontSize: '18px', fontWeight: 'bold', justifyContent: 'center',  marginBottom: '30px'}}>
          Exportar Vídeo
          </div>
        <div style={{display: 'flex', marginBottom: '10px', justifyContent: 'center'}}>
          <div style={{width: '80px'}}>FPS: </div>
          <input
            onBlur={(e) => handleChange("fps", e.target.value)}
            style={{width: '100px'}}
            placeholder={videoModel.fps}>
          </input>
        </div>
        <div style={{display: 'flex', marginBottom: '10px', justifyContent: 'center'}}>
          <div style={{width: '80px'}}>Duração: </div>
          <input
            onBlur={(e) => handleChange("duration", e.target.value)}
            style={{width: '100px'}}
            placeholder={videoModel.duration}>
          </input>
        </div>
        {/* <div style={{display: 'flex', marginBottom: '10px', justifyContent: 'center'}}>
          <div style={{width: '80px'}}>Bitrate: </div>
          <input
            onBlur={(e) => handleChange("bitrate", e.target.value)}
            style={{width: '100px'}}
            placeholder={videoModel.bitrate}>
          </input>
        </div> */}
        {
          videoModel.format !== "GIF" ?
          <div style={{display: 'flex', marginBottom: '10px', justifyContent: 'center'}}>
            <div style={{width: '80px'}}>Qualidade: </div>
            <input
              onBlur={(e) => handleChange("quality", e.target.value)}
              style={{width: '100px'}}
              placeholder={videoModel.quality}>
            </input>
          </div> :
          <>
          <div>
            <Checkbox onChange={(e) => handleChange("gifQuality", e.target.checked)} {...{ inputProps: { 'aria-label': 'Checkbox demo' } }} />
            <span style={{color: videoModel.format === "GIF" ? 'black' : 'rgba(200,200,200)'}}>Alta Qualidade</span>
          </div>
          <div>
            <Checkbox onChange={(e) => handleChange("loop", e.target.checked)} {...{ inputProps: { 'aria-label': 'Checkbox demo' } }} />
            <span style={{color: videoModel.format === "GIF" ? 'black' : 'rgba(200,200,200)'}}>Loop</span>
          </div>
          </>
        }
        <div style={{display: 'flex', marginBottom: '10px', justifyContent: 'center'}}>
          <Autocomplete          
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            inputValue={videoModel.format}
            onInputChange={(event, newInputValue) => {
                handleChange("format", newInputValue);
                }}
                disablePortal
                id="combo-box-demo"
                options={formats}
                sx={{ width: 300 }}
                renderInput={(params) => <TextField {...params} label="Formatos" />}
                />
              </div>
              {/* <div style={{display: 'flex', marginBottom: '10px', justifyContent: 'center'}}>
                <div style={{width: '80px'}}>Peso Estimado: </div>
                <input
                  style={{border: 0, fontWeight: 'bold', width: '100px'}}
                  value={
                    (
                      (
                        1.24 * (
                          videoModel.quality * 2000000 * videoModel.duration
                        ) / 800000 / 1024
                      ).toFixed(2)
                    ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kb'
                  }
                >
                </input>
              </div>               */}
              <Button
                onClick={() => {
            setConfigAvancada(!configAvancada);
          }}
          variant="outlined">
            { configAvancada ? "-" : "+" }
            Configurações Avançadas
        </Button>
        <div className='container-config-avancada' style={{ height: configAvancada ? '50px' : '0', transition: 'height 0.5s, opacity 0.5s', opacity: configAvancada ? '1' : '0' }}>
          <div style={{ opacity: configAvancada ? '1' : '0', transition: 'opacity 0.5s'}}>
            <Checkbox onChange={(e) => handleChange("bit", e.target.checked)} {...{ inputProps: { 'aria-label': 'Checkbox demo' } }} />
            <span>Utilizar formato de 10 bits</span>
          </div>
        </div>
        <Button disabled={disabledButton()} onClick={() => handleVideoExport()} variant="contained">Converter</Button>
      </div>
    </div>
  )  
}